export default "__VITE_ASSET__n4qopjyJ__"